
<!--
ORIGINAL HTML CODE
<div class="elementor-element elementor-element-2b733eab e-flex e-con-boxed e-con e-parent" data-id="2b733eab" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
                  <div class="e-con-inner">
                    <div class="elementor-element elementor-element-30a40b03 e-con-full e-flex e-con e-child" data-id="30a40b03" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                      <div class="elementor-element elementor-element-395f7f3f elementor-widget__width-inherit elementor-widget elementor-widget-image" data-id="395f7f3f" data-element_type="widget" data-widget_type="image.default">
                        <div class="elementor-widget-container">
                          <style>
                            /*! elementor - v3.19.0 - 05-02-2024 */
                            .elementor-widget-image {
                              text-align: center;
                            }

                            .elementor-widget-image a {
                              display: inline-block;
                            }

                            .elementor-widget-image a img[src$='.svg'] {
                              width: 48px;
                            }

                            .elementor-widget-image img {
                              vertical-align: middle;
                              display: inline-block;
                            }
                          </style>
                          <img fetchpriority="high" decoding="async" width="1080" height="835" src="https://socrateslegacy.com/wp-content/uploads/2024/02/sweap.png" class="attachment-full size-full wp-image-711" alt="" srcset="
                              https://socrateslegacy.com/wp-content/uploads/2024/02/sweap.png          1080w,
                              https://socrateslegacy.com/wp-content/uploads/2024/02/sweap-300x232.png   300w,
                              https://socrateslegacy.com/wp-content/uploads/2024/02/sweap-1024x792.png 1024w,
                              https://socrateslegacy.com/wp-content/uploads/2024/02/sweap-768x594.png   768w
                            " sizes="(max-width: 1080px) 100vw, 1080px">
                        </div>
                      </div>
                    </div>
                    <div class="elementor-element elementor-element-701abb2f e-con-full e-flex e-con e-child" data-id="701abb2f" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                      <div class="elementor-element elementor-element-33e01f34 e-flex e-con-boxed e-con e-child" data-id="33e01f34" data-element_type="container" data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
                        <div class="e-con-inner">
                          <div class="elementor-element elementor-element-2364b725 elementor-widget elementor-widget-heading" data-id="2364b725" data-element_type="widget" data-widget_type="heading.default">
                            <div class="elementor-widget-container">
                              <h2 class="elementor-heading-title elementor-size-default">
                                Overnight Swap Rates
                              </h2>
                            </div>
                          </div>
                          <div class="elementor-element elementor-element-1814ffa2 elementor-widget elementor-widget-text-editor" data-id="1814ffa2" data-element_type="widget" data-widget_type="text-editor.default">
                            <div class="elementor-widget-container">
                              <p class="font-medium text-base">
                                By mastering this process, traders can make
                                informed decisions regarding their positions and
                                effectively manage their trading costs. Please
                                follow these steps:
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-75e1329a e-con-full e-flex e-con e-child" data-id="75e1329a" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                        <div class="elementor-element elementor-element-349cb09c elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="349cb09c" data-element_type="widget" data-widget_type="icon-list.default">
                          <div class="elementor-widget-container">
                            <link rel="stylesheet" href="https://socrateslegacy.com/wp-content/plugins/elementor/assets/css/widget-icon-list.min.css">
                            <ul class="elementor-icon-list-items">
                              <li class="elementor-icon-list-item">
                                <span class="elementor-icon-list-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.13 156.13">
                                    <defs>
                                      <style>
                                        .cls-1 {
                                          fill: #aa8805;
                                        }

                                        .cls-2 {
                                          fill: #fff;
                                        }
                                      </style>
                                    </defs>
                                    <title>Asset 4</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                      <g id="Layer_1-2" data-name="Layer 1">
                                        <path class="cls-1" d="M68.18,64.61a8.57,8.57,0,0,0-1.65-3.25,5.17,5.17,0,0,0-2.16-1.55,7.93,7.93,0,0,0-2.93-.51,7.23,7.23,0,0,0-3.11.63,5.66,5.66,0,0,0-2.25,1.88,9.08,9.08,0,0,0-1.53,3.55,23.63,23.63,0,0,0-.49,5.15v10L68.89,69.4A21.48,21.48,0,0,0,68.18,64.61Z">
                                        </path>
                                        <path class="cls-1" d="M78.07,0a78.07,78.07,0,1,0,78.06,78.07A78.07,78.07,0,0,0,78.07,0ZM78,84.09a30.14,30.14,0,0,1-1.13,8.65A17.32,17.32,0,0,1,73.59,99a13.64,13.64,0,0,1-5.17,3.84,18.88,18.88,0,0,1-13.77,0A13.35,13.35,0,0,1,49.47,99a17.24,17.24,0,0,1-3.31-6.25A29.42,29.42,0,0,1,45,84.09V72a30.14,30.14,0,0,1,1.13-8.65,17.36,17.36,0,0,1,3.29-6.28A13.86,13.86,0,0,1,54.6,53.3,17.2,17.2,0,0,1,61.44,52a17.51,17.51,0,0,1,6.93,1.31,13.85,13.85,0,0,1,5.19,3.81,18,18,0,0,1,3.27,6.28A29.42,29.42,0,0,1,78,72Zm33.14,19.32H102V63.76l-12.91,4.7V60.55l21.48-7.83h.52Z">
                                        </path>
                                        <path class="cls-1" d="M54.71,91.14a9.07,9.07,0,0,0,1.34,3,5.76,5.76,0,0,0,2.28,2,7,7,0,0,0,3.18.68,7.42,7.42,0,0,0,3.12-.61,5.49,5.49,0,0,0,2.24-1.86,9.58,9.58,0,0,0,1.55-3.64,23.28,23.28,0,0,0,.51-5.2V75.91L54.1,87A20.82,20.82,0,0,0,54.71,91.14Z">
                                        </path>
                                        <path class="cls-2" d="M73.56,57.11a13.85,13.85,0,0,0-5.19-3.81A17.51,17.51,0,0,0,61.44,52,17.2,17.2,0,0,0,54.6,53.3a13.86,13.86,0,0,0-5.17,3.81,17.36,17.36,0,0,0-3.29,6.28A30.14,30.14,0,0,0,45,72v12a29.42,29.42,0,0,0,1.15,8.65A17.24,17.24,0,0,0,49.47,99a13.35,13.35,0,0,0,5.18,3.86,18.88,18.88,0,0,0,13.77,0A13.64,13.64,0,0,0,73.59,99a17.32,17.32,0,0,0,3.26-6.25A30.14,30.14,0,0,0,78,84.09V72a29.42,29.42,0,0,0-1.15-8.65A18,18,0,0,0,73.56,57.11ZM54.06,78.87V70.51a23.63,23.63,0,0,1,.49-5.15,9.08,9.08,0,0,1,1.53-3.55,5.66,5.66,0,0,1,2.25-1.88,7.23,7.23,0,0,1,3.11-.63,7.93,7.93,0,0,1,2.93.51,5.17,5.17,0,0,1,2.16,1.55,8.57,8.57,0,0,1,1.65,3.25,21.48,21.48,0,0,1,.71,4.79L54.06,80.54Zm14.87-1.24v7.92a23.28,23.28,0,0,1-.51,5.2,9.58,9.58,0,0,1-1.55,3.64,5.49,5.49,0,0,1-2.24,1.86,7.42,7.42,0,0,1-3.12.61,7,7,0,0,1-3.18-.68,5.76,5.76,0,0,1-2.28-2,9.07,9.07,0,0,1-1.34-3A20.82,20.82,0,0,1,54.1,87L68.93,75.91Z">
                                        </path>
                                        <polygon class="cls-2" points="89.12 60.55 89.12 68.46 102.03 63.76 102.03 103.41 111.12 103.41 111.12 52.72 110.6 52.72 89.12 60.55">
                                        </polygon>
                                      </g>
                                    </g>
                                  </svg>
                                </span>
                                <span class="elementor-icon-list-text">Right-click on any instrument in the 'Market
                                  Watch' section.</span>
                              </li>
                              <li class="elementor-icon-list-item">
                                <span class="elementor-icon-list-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.13 156.13">
                                    <defs>
                                      <style>
                                        .cls-1 {
                                          fill: #aa8805;
                                        }

                                        .cls-2 {
                                          fill: #fff;
                                        }
                                      </style>
                                    </defs>
                                    <title>Asset 5</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                      <g id="Layer_1-2" data-name="Layer 1">
                                        <path class="cls-1" d="M49.9,91.14a9.28,9.28,0,0,0,1.34,3,6,6,0,0,0,2.28,2,7.16,7.16,0,0,0,3.19.67,7.46,7.46,0,0,0,3.12-.61,5.49,5.49,0,0,0,2.24-1.86,9.74,9.74,0,0,0,1.55-3.64,23.94,23.94,0,0,0,.5-5.2V75.91L49.29,87A22.38,22.38,0,0,0,49.9,91.14Z">
                                        </path>
                                        <path class="cls-1" d="M63.38,64.61a8.58,8.58,0,0,0-1.66-3.25,5.17,5.17,0,0,0-2.16-1.55,7.88,7.88,0,0,0-2.92-.51,7.3,7.3,0,0,0-3.12.63,5.7,5.7,0,0,0-2.24,1.88,8.79,8.79,0,0,0-1.53,3.55,23.63,23.63,0,0,0-.49,5.15v10L64.09,69.4A21.48,21.48,0,0,0,63.38,64.61Z">
                                        </path>
                                        <path class="cls-1" d="M78.07,0a78.07,78.07,0,1,0,78.06,78.07A78.07,78.07,0,0,0,78.07,0Zm-4.9,84.09A29.79,29.79,0,0,1,72,92.74,17.31,17.31,0,0,1,68.79,99a13.72,13.72,0,0,1-5.17,3.84,18.88,18.88,0,0,1-13.77,0A13.45,13.45,0,0,1,44.66,99a17.22,17.22,0,0,1-3.3-6.25,29.42,29.42,0,0,1-1.15-8.65V72a29.79,29.79,0,0,1,1.13-8.65,17.21,17.21,0,0,1,3.29-6.28A13.78,13.78,0,0,1,49.8,53.3,17.2,17.2,0,0,1,56.64,52a17.55,17.55,0,0,1,6.93,1.31,13.73,13.73,0,0,1,5.18,3.81A17.82,17.82,0,0,1,72,63.39,29.77,29.77,0,0,1,73.17,72Zm42.75,19.32H81.63v-6.2L98.07,79.42q2-2.16,3.34-3.91a29.86,29.86,0,0,0,2.19-3.22,11.57,11.57,0,0,0,1.2-2.7,9.16,9.16,0,0,0,.37-2.49,9,9,0,0,0-.51-3.15,6.24,6.24,0,0,0-3.74-3.9A7.68,7.68,0,0,0,98,59.51a10.23,10.23,0,0,0-3.63.59,7.19,7.19,0,0,0-2.6,1.67,7.75,7.75,0,0,0-1.58,2.82,12.37,12.37,0,0,0-.54,3.8h-9a16.2,16.2,0,0,1,1.25-6.32,15.49,15.49,0,0,1,3.59-5.21A16.14,16.14,0,0,1,91,53.31,19.9,19.9,0,0,1,98.24,52,19.59,19.59,0,0,1,105,53.11a14.06,14.06,0,0,1,5,3,13.1,13.1,0,0,1,3,4.65,16.16,16.16,0,0,1,1,5.93,14.45,14.45,0,0,1-.78,4.74,22.05,22.05,0,0,1-2.18,4.49,41.86,41.86,0,0,1-3.39,4.47q-2,2.28-4.3,4.72L93,96.17h22.94Z">
                                        </path>
                                        <path class="cls-2" d="M68.75,57.11a13.73,13.73,0,0,0-5.18-3.81A17.55,17.55,0,0,0,56.64,52,17.2,17.2,0,0,0,49.8,53.3a13.78,13.78,0,0,0-5.17,3.81,17.21,17.21,0,0,0-3.29,6.28A29.79,29.79,0,0,0,40.21,72v12a29.42,29.42,0,0,0,1.15,8.65A17.22,17.22,0,0,0,44.66,99a13.45,13.45,0,0,0,5.19,3.86,18.88,18.88,0,0,0,13.77,0A13.72,13.72,0,0,0,68.79,99,17.31,17.31,0,0,0,72,92.74a29.79,29.79,0,0,0,1.13-8.65V72A29.77,29.77,0,0,0,72,63.39,17.82,17.82,0,0,0,68.75,57.11ZM49.26,78.87V70.51a23.63,23.63,0,0,1,.49-5.15,8.79,8.79,0,0,1,1.53-3.55,5.7,5.7,0,0,1,2.24-1.88,7.3,7.3,0,0,1,3.12-.63,7.88,7.88,0,0,1,2.92.51,5.17,5.17,0,0,1,2.16,1.55,8.58,8.58,0,0,1,1.66,3.25,21.48,21.48,0,0,1,.71,4.79L49.26,80.54Zm14.86-1.24v7.92a23.94,23.94,0,0,1-.5,5.2,9.74,9.74,0,0,1-1.55,3.64,5.49,5.49,0,0,1-2.24,1.86,7.46,7.46,0,0,1-3.12.61,7.16,7.16,0,0,1-3.19-.67,6,6,0,0,1-2.28-2,9.28,9.28,0,0,1-1.34-3A22.38,22.38,0,0,1,49.29,87L64.12,75.91Z">
                                        </path>
                                        <path class="cls-2" d="M103.39,85.1q2.34-2.44,4.3-4.72a41.86,41.86,0,0,0,3.39-4.47,22.05,22.05,0,0,0,2.18-4.49,14.45,14.45,0,0,0,.78-4.74,16.16,16.16,0,0,0-1-5.93,13.1,13.1,0,0,0-3-4.65,14.06,14.06,0,0,0-5-3A19.59,19.59,0,0,0,98.24,52,19.9,19.9,0,0,0,91,53.31a16.14,16.14,0,0,0-5.53,3.55,15.49,15.49,0,0,0-3.59,5.21,16.2,16.2,0,0,0-1.25,6.32h9a12.37,12.37,0,0,1,.54-3.8,7.75,7.75,0,0,1,1.58-2.82,7.19,7.19,0,0,1,2.6-1.67A10.23,10.23,0,0,1,98,59.51a7.68,7.68,0,0,1,2.93.54,6.24,6.24,0,0,1,3.74,3.9,9,9,0,0,1,.51,3.15,9.16,9.16,0,0,1-.37,2.49,11.57,11.57,0,0,1-1.2,2.7,29.86,29.86,0,0,1-2.19,3.22q-1.36,1.76-3.34,3.91L81.63,97.21v6.2h34.29V96.17H93Z">
                                        </path>
                                      </g>
                                    </g>
                                  </svg>
                                </span>
                                <span class="elementor-icon-list-text">Left-click on the 'Specification' option from
                                  the dropdown menu.</span>
                              </li>
                              <li class="elementor-icon-list-item">
                                <span class="elementor-icon-list-icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.13 156.13">
                                    <defs>
                                      <style>
                                        .cls-1 {
                                          fill: #aa8805;
                                        }

                                        .cls-2 {
                                          fill: #fff;
                                        }
                                      </style>
                                    </defs>
                                    <title>Asset 6</title>
                                    <g id="Layer_2" data-name="Layer 2">
                                      <g id="Layer_1-2" data-name="Layer 1">
                                        <path class="cls-1" d="M63.53,64.61a8.43,8.43,0,0,0-1.65-3.25,5.17,5.17,0,0,0-2.16-1.55,7.88,7.88,0,0,0-2.92-.51,7.24,7.24,0,0,0-3.12.63,5.8,5.8,0,0,0-2.25,1.88,9.08,9.08,0,0,0-1.53,3.55,24.27,24.27,0,0,0-.49,5.15v10L64.24,69.4A21.48,21.48,0,0,0,63.53,64.61Z">
                                        </path>
                                        <path class="cls-1" d="M50.06,91.14a9.07,9.07,0,0,0,1.34,3,5.76,5.76,0,0,0,2.28,2,7,7,0,0,0,3.19.68A7.38,7.38,0,0,0,60,96.25a5.58,5.58,0,0,0,2.25-1.86,9.91,9.91,0,0,0,1.55-3.64,23.94,23.94,0,0,0,.5-5.2V75.91L49.45,87A21.57,21.57,0,0,0,50.06,91.14Z">
                                        </path>
                                        <path class="cls-1" d="M78.07,0a78.07,78.07,0,1,0,78.06,78.07A78.07,78.07,0,0,0,78.07,0ZM73.33,84.09a30.14,30.14,0,0,1-1.13,8.65A17.17,17.17,0,0,1,68.94,99a13.61,13.61,0,0,1-5.16,3.84,18.88,18.88,0,0,1-13.77,0A13.28,13.28,0,0,1,44.82,99a17.24,17.24,0,0,1-3.31-6.25,29.76,29.76,0,0,1-1.15-8.65V72a29.77,29.77,0,0,1,1.14-8.65,17.21,17.21,0,0,1,3.29-6.28A13.74,13.74,0,0,1,50,53.3,17.29,17.29,0,0,1,56.8,52a17.5,17.5,0,0,1,6.92,1.31,13.85,13.85,0,0,1,5.19,3.81,17.65,17.65,0,0,1,3.27,6.28A29.42,29.42,0,0,1,73.33,72Zm41.11,11.45a13.22,13.22,0,0,1-3.65,4.67,15.87,15.87,0,0,1-5.5,2.9,23.28,23.28,0,0,1-6.89,1,22.09,22.09,0,0,1-6.29-.9,16.49,16.49,0,0,1-5.41-2.72A12.85,12.85,0,0,1,82.94,96a13.49,13.49,0,0,1-1.39-6.28h9a6.79,6.79,0,0,0,.59,2.87,6.36,6.36,0,0,0,1.67,2.24,7.22,7.22,0,0,0,2.52,1.5,9.73,9.73,0,0,0,3.26.52,10.63,10.63,0,0,0,3.5-.54,7,7,0,0,0,2.63-1.58,6.06,6.06,0,0,0,1.58-2.35,9,9,0,0,0,.54-3.22,9.29,9.29,0,0,0-.65-3.64A6.54,6.54,0,0,0,104.38,83a7.84,7.84,0,0,0-2.89-1.48,13.82,13.82,0,0,0-3.72-.47H92.62v-7h5.15a10.56,10.56,0,0,0,3.74-.59,6.56,6.56,0,0,0,2.59-1.67,6,6,0,0,0,1.43-2.32,8.65,8.65,0,0,0,.49-3,9,9,0,0,0-.47-3,5.9,5.9,0,0,0-3.73-3.69,10.06,10.06,0,0,0-3.25-.48,9.33,9.33,0,0,0-3,.45,6.75,6.75,0,0,0-2.33,1.29,5.9,5.9,0,0,0-1.62,2.09,6.41,6.41,0,0,0-.58,2.75h-9a12.58,12.58,0,0,1,1.24-5.61,13.6,13.6,0,0,1,3.43-4.42,16.44,16.44,0,0,1,5.17-2.84,19.75,19.75,0,0,1,6.46-1,23.2,23.2,0,0,1,6.75.92,15,15,0,0,1,5.26,2.73,12.55,12.55,0,0,1,3.39,4.54,15.17,15.17,0,0,1,1.2,6.22,11.33,11.33,0,0,1-1.88,6.2,12.81,12.81,0,0,1-2.35,2.68,14.08,14.08,0,0,1-3.29,2.08,14,14,0,0,1,3.78,2,11.13,11.13,0,0,1,2.59,2.73,12.52,12.52,0,0,1,1.45,3.36,14.94,14.94,0,0,1,.47,3.75A14.49,14.49,0,0,1,114.44,95.54Z">
                                        </path>
                                        <path class="cls-2" d="M68.91,57.11a13.85,13.85,0,0,0-5.19-3.81A17.5,17.5,0,0,0,56.8,52,17.29,17.29,0,0,0,50,53.3a13.74,13.74,0,0,0-5.16,3.81,17.21,17.21,0,0,0-3.29,6.28A29.77,29.77,0,0,0,40.36,72v12a29.76,29.76,0,0,0,1.15,8.65A17.24,17.24,0,0,0,44.82,99,13.28,13.28,0,0,0,50,102.85a18.88,18.88,0,0,0,13.77,0A13.61,13.61,0,0,0,68.94,99a17.17,17.17,0,0,0,3.26-6.25,30.14,30.14,0,0,0,1.13-8.65V72a29.42,29.42,0,0,0-1.15-8.65A17.65,17.65,0,0,0,68.91,57.11ZM49.41,78.87V70.51a24.27,24.27,0,0,1,.49-5.15,9.08,9.08,0,0,1,1.53-3.55,5.8,5.8,0,0,1,2.25-1.88,7.24,7.24,0,0,1,3.12-.63,7.88,7.88,0,0,1,2.92.51,5.17,5.17,0,0,1,2.16,1.55,8.43,8.43,0,0,1,1.65,3.25,21.48,21.48,0,0,1,.71,4.79L49.41,80.54Zm14.87-1.24v7.92a23.94,23.94,0,0,1-.5,5.2,9.91,9.91,0,0,1-1.55,3.64A5.58,5.58,0,0,1,60,96.25a7.38,7.38,0,0,1-3.11.61,7,7,0,0,1-3.19-.68,5.76,5.76,0,0,1-2.28-2,9.07,9.07,0,0,1-1.34-3A21.57,21.57,0,0,1,49.45,87L64.28,75.91Z">
                                        </path>
                                        <path class="cls-2" d="M113.85,82.1a11.13,11.13,0,0,0-2.59-2.73,14,14,0,0,0-3.78-2,14.08,14.08,0,0,0,3.29-2.08,12.81,12.81,0,0,0,2.35-2.68,11.33,11.33,0,0,0,1.88-6.2,15.17,15.17,0,0,0-1.2-6.22,12.55,12.55,0,0,0-3.39-4.54A15,15,0,0,0,105.15,53,23.2,23.2,0,0,0,98.4,52a19.75,19.75,0,0,0-6.46,1,16.44,16.44,0,0,0-5.17,2.84,13.6,13.6,0,0,0-3.43,4.42,12.58,12.58,0,0,0-1.24,5.61h9a6.41,6.41,0,0,1,.58-2.75,5.9,5.9,0,0,1,1.62-2.09,6.75,6.75,0,0,1,2.33-1.29,9.33,9.33,0,0,1,3-.45,10.06,10.06,0,0,1,3.25.48,5.9,5.9,0,0,1,3.73,3.69,9,9,0,0,1,.47,3,8.65,8.65,0,0,1-.49,3,6,6,0,0,1-1.43,2.32,6.56,6.56,0,0,1-2.59,1.67,10.56,10.56,0,0,1-3.74.59H92.62v7h5.15a13.82,13.82,0,0,1,3.72.47A7.84,7.84,0,0,1,104.38,83a6.54,6.54,0,0,1,1.79,2.49,9.29,9.29,0,0,1,.65,3.64,9,9,0,0,1-.54,3.22,6.06,6.06,0,0,1-1.58,2.35,7,7,0,0,1-2.63,1.58,10.63,10.63,0,0,1-3.5.54,9.73,9.73,0,0,1-3.26-.52,7.22,7.22,0,0,1-2.52-1.5,6.36,6.36,0,0,1-1.67-2.24,6.79,6.79,0,0,1-.59-2.87h-9A13.49,13.49,0,0,0,82.94,96a12.85,12.85,0,0,0,3.76,4.47,16.49,16.49,0,0,0,5.41,2.72,22.09,22.09,0,0,0,6.29.9,23.28,23.28,0,0,0,6.89-1,15.87,15.87,0,0,0,5.5-2.9,13.22,13.22,0,0,0,3.65-4.67,14.49,14.49,0,0,0,1.33-6.33,14.94,14.94,0,0,0-.47-3.75A12.52,12.52,0,0,0,113.85,82.1Z">
                                        </path>
                                      </g>
                                    </g>
                                  </svg>
                                </span>
                                <span class="elementor-icon-list-text">A window will open displaying the long and
                                  short swap rates for the selected currency
                                  pair.</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
-->

<template>
  <div class="swap-rates">
    <!-- Overnight Swap Rates Section -->
    <div class="swap-content">
      <div class="content-container">
        <div class="image-section">
          <img 
            alt="Swap Rates" 
            class="swap-illustration" 
            src="/wp-content/uploads/2024/02/sweap.png"
          />
        </div>
        <div class="text-section">
          <div class="text-content">
            <h2 class="section-title">Overnight Swap Rates</h2>
            <p class="section-description">
              By mastering this process, traders can make informed decisions regarding their positions and effectively manage their trading costs. Please follow these steps:
            </p>
            <div class="steps-list">
              <div v-for="step in steps" :key="step.id" class="step-item">
                <div class="step-number">
                  {{ step.number }}
                </div>
                <div class="step-text">
                  {{ step.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwapRates',
  data() {
    return {
      steps: [
        {
          id: 1,
          number: '01',
          text: 'Right-click on any instrument in the \'Market Watch\' section.'
        },
        {
          id: 2,
          number: '02',
          text: 'Left-click on the \'Specification\' option from the dropdown menu.'
        },
        {
          id: 3,
          number: '03',
          text: 'A window will open displaying the long and short swap rates for the selected currency pair.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.swap-rates {
  background: linear-gradient(330deg, rgb(0,0,0) 0%, rgb(58,42,0) 100%);
  padding: 80px 0;
  position: relative;
}

.swap-rates .swap-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.swap-rates .content-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.swap-rates .image-section {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swap-rates .image-section::before {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  background: white;
  border-radius: 50%;
  z-index: 1;
}

.swap-rates .swap-illustration {
  position: relative;
  z-index: 2;
  max-width: 500px;
  width: 100%;
  height: auto;
}

.swap-rates .text-section {
  color: white;
}

.swap-rates .section-title {
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin: 0 0 20px 0;
  line-height: 1.2;
}

.swap-rates .section-description {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 40px 0;
  line-height: 1.6;
}

.swap-rates .steps-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.swap-rates .step-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.swap-rates .step-number {
  width: 50px;
  height: 50px;
  background: #B8860B;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(184, 134, 11, 0.3);
}

.swap-rates .step-text {
  font-size: 1rem;
  color: white;
  line-height: 1.5;
  padding-top: 12px;
}

@media (max-width: 768px) {
  .swap-rates .content-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
  
  .swap-rates .section-title {
    font-size: 2.2rem;
  }
  
  .swap-rates .image-section::before {
    width: 300px;
    height: 300px;
  }
  
  .swap-rates .swap-illustration {
    max-width: 350px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .swap-rates .content-container {
    gap: 40px;
  }
  
  .swap-rates .section-title {
    font-size: 2.5rem;
  }
}
</style>
